<template>
    <div class="pt-15 animated fadeIn chartOfAccount equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card fullContent class="mb-0 heig-frame-child">
                        <gofix-default-table :settings="tableConfig" :table-items="tableItems" @new-item="openModal" @load-items="getTableData" @row-click="edit" @download-items="donwloadItems" @delete-items="deleteItems" @email-send-items="emailSendItems" ref="gofixTable">
                            <template slot="gofix_table:actions" slot-scope="data" v-if="data.item.status === 'Posted'">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                            <template slot="gofix_table:file_name" slot-scope="row">
                                {{ row.item.path_info_extension == 'PDF' ? row.item.file_name + ' support' : row.item.file_name }}
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{ row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY") }}
                            </template>
                            <template slot="gofix_table:s3_url" slot-scope="row">
                                <div class="download-file" @click.stop="downloadFile(row.item)">
                                    <svg width="13" height="13" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.78216 9.13875L8.80055 11.2538V1.5C8.80055 0.88125 9.28367 0.375 9.87416 0.375C10.4646 0.375 10.9478 0.88125 10.9478 1.5V11.2538L12.9769 9.13875C13.3956 8.7 14.072 8.7 14.4907 9.13875C14.6917 9.34894 14.8047 9.63429 14.8047 9.93188C14.8047 10.2295 14.6917 10.5148 14.4907 10.725L10.6364 14.7638C10.2177 15.2025 9.54134 15.2025 9.12263 14.7638L5.26837 10.725C4.84967 10.2863 4.84967 9.5775 5.26837 9.13875C5.68708 8.7 6.36345 8.7 6.78216 9.13875ZM17.4004 17.25V11.625C17.4004 11.0062 17.8835 10.5 18.474 10.5C19.0645 10.5 19.5476 11.0062 19.5476 11.625V18.375C19.5476 19.6125 18.5814 20.625 17.4004 20.625H2.36987C1.1889 20.625 0.222656 19.6125 0.222656 18.375V11.625C0.222656 11.0062 0.70578 10.5 1.29626 10.5C1.88675 10.5 2.36987 11.0062 2.36987 11.625V17.25C2.36987 17.8687 2.853 18.375 3.44348 18.375H16.3268C16.9173 18.375 17.4004 17.8687 17.4004 17.25Z" fill="#0f7dfe" />
                                    </svg>
                                    <span>{{ row.item.path_info_extension }}</span>
                                </div>
                            </template>
                            <template slot="gofix_table:before-control-right" slot-scope="data">
                                <div class="mr-4 d-flex align-items-center filterCompany">
                                    <span class="mr-3 title">Finance Company</span>
                                    <gofix-form-dropdown class="highlightDropdown chartOfAccountDropdown" label="" vLabel="name" :reduce="option => option.id" :searchable="false" placeholder="Filter by company" :options="financeCompanies" v-model="coa_company_filter">
                                    </gofix-form-dropdown>
                                </div>
                            </template>
                        </gofix-default-table>
                        <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" title="Change Status" hide-footer :centered="true" ref="modal-status">
                            <b-form class="pb-20">
                                <b-row>
                                    <b-col md="12">
                                        <gofix-form-dropdown label="Status" v-model="navision_file.status" :options="['Posted']">
                                        </gofix-form-dropdown>
                                    </b-col>
                                </b-row>
                            </b-form>
                            <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.navision_file_listing, 'update')">
                                <gofix-button label="SUBMIT" @click="updateNavision" :loading="isAction" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>
                        <b-modal :no-close-on-backdrop="true" id="modal-EditPrioritySet" title="Export A New Batch" hide-footer :centered="true" ref="modal-export">
                            <b-form class="pb-20 formV2">
                                <b-row class="content">
                                    <b-col md="12">
                                        <gofix-form-input-date v-model="navision_file.export_date" label="Export Upto Date">
                                        </gofix-form-input-date>
                                    </b-col>
                                    <b-col md="12">
                                        <div class="field">
                                            <label class="font-weight-bold">Select Type</label>
                                        </div>
                                    </b-col>
                                    <b-col md="12">
                                        <div class="custom-checkbox-modal">
                                            <b-form-checkbox-group id="checkbox-group-2" v-model="navision_file.type">
                                                <b-form-checkbox value="PAP">PAP</b-form-checkbox>
                                                <b-form-checkbox value="REC">REC</b-form-checkbox>
                                                <b-form-checkbox value="PGL">PGL</b-form-checkbox>
                                            </b-form-checkbox-group>
                                            <b-form-checkbox-group id="checkbox-group-2" v-model="navision_file.type" class="mt-15">
                                                <b-form-checkbox value="OFF">OFF</b-form-checkbox>
                                                <b-form-checkbox value="INV">INV</b-form-checkbox>
                                            </b-form-checkbox-group>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-form>
                            <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.navision_file_listing, 'create')">
                                <gofix-button label="SUBMIT" @click="saveNavisionFile" :loading="isAction" noBorder></gofix-button>
                            </b-button-group>
                        </b-modal>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import { filters } from '@/_filterVar.js'
import { mapGetters } from "vuex";
import moment from 'moment';
export default {
    name: 'navision-files-menu',
    data() {
        return {
            tableConfig: {
                name: 'finance-navision-file-listing',
                controls: {
                    create: this.$checkRole(this.$accessModule.navision_file_listing, 'create'),
                    delete: this.$checkRole(this.$accessModule.navision_file_listing, 'delete'),
                    update: this.$checkRole(this.$accessModule.navision_file_listing, 'update'),
                    download: true,
                    email_send: true,
                    modalTitleDelete: 'These files and the other related files will be deleted.<br/>Are you sure you want to <strong>continue</strong>?'
                },
                filter: JSON.parse(JSON.stringify(filters['navision_file_menu'])),
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "id",
                sortDirection: "desc",
            },
            tableItems: [],
            isAction: false,
            navision_file: {
                id: 0,
                type: ['PAP'],
                export_date: new Date(),
                status: '',
                file_name: '',
            },
            financeCompanies: [],
            coa_company_filter: null,
        }
    },
    computed: {
        ...mapGetters({
            Items: "NavisionFileController/Items"
        })
    },
    created() {
        this.getFinanceCompanies();
    },
    watch: {
        coa_company_filter: function(val) {
            this.$refs.gofixTable.reloadTableItems();
        }
    },
    methods: {
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            this.$store.dispatch("NavisionFileController/deteleItem", ids)
                .then(response => {
                    resolve(this.$notificationV2('deleting', 'navision_file'));
                })
                .catch(err => {
                    reject(err);
                });
        },
        async emailSendItems(callback) {
            // const { ids,filter, resolve,reject } = await callback();
        },
        openModal() {
            this.navision_file.id = 0;
            this.$refs["modal-export"].show();
        },
        async downloadFile(item) {
            if (item.s3_url || item.s3_url_pdf) {
                let linkDownload = item.s3_url
                let fileName = item.file_name
                if (item.path_info_extension == 'PDF') {
                    fileName += ' support'
                    linkDownload = item.s3_url_pdf
                }
                await axios({
                        url: linkDownload,
                        method: 'GET',
                        responseType: 'blob',
                        headers: {
                            'Authorization': ''
                        } // important
                    }).then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `${fileName}.${item.path_info_extension.toLowerCase()}`);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(error => {
                        this.$alertNotification("Error!", "danger");
                    });
            }
        },
        async donwloadItems(ids) {
            if (!ids) return;
            let itemDownloads = this.tableItems.filter(item => ids.includes(item.id))
			const _this = this
            for (let i = 0; i < itemDownloads.length; i++) {			
                setTimeout(async function (){
                    await _this.downloadFile(itemDownloads[i]);
                }, 500);
            }
        },
        saveNavisionFile() {
            if (this.isAction) {
                return;
            }
            this.isAction = true;
            if (!this.navision_file.export_date) {
                this.isAction = false;
                return this.$alertNotification("Export upto Date is a required field.", "danger");
            }
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            let request = Object.assign({}, this.navision_file);
            request.export_date = moment(request.export_date).format("YYYY-MM-DD");
            this.timer = setTimeout(() => {
                this.$store.dispatch('NavisionFileController/exportNavision', request)
                    .then(result => {
                        this.isAction = false;
                        this.$alertNotification("Successfully exported navision file");
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$refs["modal-export"].hide();
                    })
                    .catch(error => {
                        console.log(error)
                        this.isAction = false;
                        if (error.response.data.error.message) {
                            return this.$alertNotification(error.response.data.error.message, "danger");
                        }
                        this.$alertNotification("Error", "danger");
                    })
            }, 300)
        },
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            if (this.coa_company_filter) {
                tableRequest.filter.coa_company_id.value = this.coa_company_filter;
            }
            await this.$store.dispatch("NavisionFileController/getList", tableRequest)
                .then(response => {
                    this.tableItems = response.data.data.items;
                    this.tableConfig.total = response.data.data.total;
                    resolve(response.data.data);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load items", "danger");
                    reject();
                })
        },
        updateNavision() {
            if (this.isAction) {
                return;
            }
            this.isAction = true;
            if (!this.navision_file.status) {
                this.isAction = false;
                return this.$alertNotification("Status is a required field.", "danger");
            }
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                this.$store.dispatch('NavisionFileController/updateItem', { id: this.navision_file.id, status: this.navision_file.status })
                    .then(result => {
                        this.isAction = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(`Successfully Updated ${this.navision_file.file_name}`);
                        this.$refs["modal-status"].hide();
                    })
                    .catch(error => {
                        this.isAction = false;
                        this.$alertNotification("Error!", "danger");
                    })
            }, 300)
        },
        edit(item) {
            this.navision_file.id = item.id;
            this.navision_file.status = item.status;
            this.navision_file.file_name = item.file_name
            this.$refs['modal-status'].show()
        },
        openModal() {
            this.navision_file.id = 0;
            this.$refs["modal-export"].show();
        },
        getFinanceCompanies() {
            this.$store.dispatch("ChartOfAccountController/getCompanies", {
                limit: -1,
                page: 1
            }).then(response => {
                this.financeCompanies = response.items;
            })
            .catch(err => {
                console.log(err);
            })
        },
    }
}
</script>